import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

// Thiết lập múi giờ mặc định theo trình duyệt
dayjs.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone)

export default dayjs
